var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeDetalhamentoDescricao(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 16,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36D896",
    fillRule: "evenodd",
    d: "M2 0h16c1.10321045.0032959 1.9967041.89678955 2 2v12c-.0032959 1.10321045-.89678955 1.9967041-2 2H2c-1.10319519-.0032959-1.9967041-.89678955-2-2V2C.0032959.89678955.89680481.0032959 2 0zm0 14h16V2H2v12z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 4,
    y: 6,
    fill: "#36D896",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 4,
    y: 10,
    fill: "#36D896",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 14,
    y: 10,
    fill: "#36D896",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 8,
    y: 6,
    fill: "#36D896",
    rx: 0,
    ry: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeDetalhamentoDescricao);
export default __webpack_public_path__ + "static/media/icone-detalhamento-descricao.9a7b6f80dcae813c0f613b8919f88365.svg";
export { ForwardRef as ReactComponent };